import { render } from "./CustomMultiSelectDocumentType.vue?vue&type=template&id=fad5d6c4"
import script from "./CustomMultiSelectDocumentType.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelectDocumentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__